import { AppStore } from './store';

/*
 * 初始化 Redux 上下文
 * 该文件用于处理远程数据与本地 Redux 状态的交互
 */
export function setupRedux(store: AppStore) {
  // console.log('store', store);
}
